export default function() {
  /* 表格列头 */
  return [
    { label: "", type: "selection", width: 50 },
    { label: "门店名称", prop: "store_name", slots: "storeName", minWidth: 170 },
    { label: "联系人", prop: "boss_name", width: 110 },
    { label: "联系电话", prop: "store_phone", width: 140 },
    { label: "标签", prop: "tag", slots: "tag", width: 100 },
    { label: "来源", prop: "source", width: 90 },
    { label: "状态", prop: "status", width: 90 },
    { label: "门店ID", prop: "id", width: 90 },
    { label: "用户ID", prop: "user_id", width: 100 },
    { label: "创建时间", prop: "create_time", width: 170 },
    {
      label: "操作",
      prop: "operation",
      width: 220,
      slots: "operation",
    },
  ];
}
